import React from "react";

const TickIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="11" fill="#00770C" />
      <rect
        x="15.6855"
        y="5.58301"
        width="3.29497"
        height="12.5023"
        rx="1.64749"
        transform="rotate(39.8964 15.6855 5.58301)"
        fill="#F1F1F1"
      />
      <rect
        x="4.02441"
        y="12.1807"
        width="3.20058"
        height="7.97086"
        rx="1.60029"
        transform="rotate(-50.1036 4.02441 12.1807)"
        fill="#F1F1F1"
      />
    </svg>
  );
};

export default TickIcon;
